export default __webpack_public_path__ + "static/media/higher-active.9c22bedd.svg";